import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Amplify } from "aws-amplify";

// AWS Amplify Configuration (without authentication)
Amplify.configure({
  API: {
    endpoints: [
      {
        name: "DealsSiteAPI",
        endpoint: "https://12ntepajjg.execute-api.us-east-1.amazonaws.com/dev",
        region: "us-east-1",
        service: "execute-api",
        authenticationType: "NONE", // Disable authentication for now
      },
    ],
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

reportWebVitals();
